/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 9/11/19.
 */

function DynamicPropertiesEditServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    BreadcrumbService: JS5Object,
    DynamicPropertiesService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
) {

    //=============//
    // Breadcrumbs //
    //=============//

    this.resetBreadcrumbs = () => {
        BreadcrumbService.clearBreadcrumbs();
    };

    if (BreadcrumbService.getBreadcrumbs().length === 0) {
        this.resetBreadcrumbs();
    }


    //==========//
    // Requests //
    //==========//

    this.originalPropertyValue = null;
    this.editData = null;

    this.getViewPermissions = () => {
        return PermissionsService.isAdmin();
    };

    this.getEditData = (propertyName: string) => {
        return DynamicPropertiesService.queryForProperties()
            .then(() => {
                return {
                    name: propertyName,
                    value: DynamicPropertiesService.getPropValue(propertyName, undefined),
                    hasConfidentialInfo: DynamicPropertiesService.propContainsConfidentialInfo(propertyName)
                };
            });
    };


    //====================//
    // Edit View Handlers //
    //====================//

    this.editorForm = null;

    const closeEditView = () => {
        BreadcrumbService.clearBreadcrumbs();
        this.originalPropertyValue = null;
        this.editData = null;
        this.editorForm = null;
        $location.path(`/system/properties/search`);
        $location.search('propertyName', null);
        $location.search('tab', 'DynamicProps');
    };

    this.revertEditData = () => {
        if (this.originalPropertyValue) {
            this.editorForm.$setPristine();
            this.editData.value = _.cloneDeep(this.originalPropertyValue);
        } else {
            closeEditView();
        }
    };

    this.saveEditData = () => {
        if (!DynamicPropertiesService.propNameIsValid(this.editData.name)) {
            return $q.reject('Property has an invalid name. Does it use a $ at the start of the name?', '');
        } else if (!DynamicPropertiesService.propIsEditable(this.editData.name)) {
            return $q.reject('Cannot use this property name. It is reserved for internal use.', '');
        } else if (!this.originalPropertyValue && !_.isNull(DynamicPropertiesService.getPropValue(this.editData.name, null))) {
            return $q.reject('Property already exists. Please select a different name.', '');
        }

        this.editData.value = this.editData.value.replace(/[\t\r\n]/g, '');
        return DynamicPropertiesService.saveProperty(
            this.editData.name,
            this.editData.value
        ).then(() => {
            this.originalPropertyValue = this.editData.value;
            this.editorForm.$setPristine();
        });
    };

    const showUnsavedChangesNotification = () => {
        NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
    };

    this.exitEdit = () => {
        if (this.originalPropertyValue && this.editorForm.$pristine) {
            closeEditView();
        } else {
            showUnsavedChangesNotification();
        }
    };
}

angular
    .module('prism-ui.system')
    .service('DynamicPropertiesEditService', DynamicPropertiesEditServiceConstructor);
